export const API_URL = process.env.REACT_APP_IS_STAGGING === "stagging" ? 
  'https://webapi-stg.neuralprisma.com' :
  process.env.NODE_ENV === 'development' ?
  'http://localhost:8080/' :
  'https://webapi.neuralprisma.com'